import { gql } from '@apollo/client';
import { USER_ENROLMENTS, USER_PROFILES, USER_SUMMARY } from '../fragments';

/**
 * Paged, and capped server-side. The old query asked for every user at once
 * with a client-supplied `orderBy`; ordering is now fixed by the repository.
 */
export const GET_ALL_USERS = gql`
  query getAllUsers($input: ListUsersInput) {
    Users(input: $input) {
      users {
        ...UserSummary
        ...UserEnrolments
      }
      nextCursor
    }
  }
  ${USER_SUMMARY}
  ${USER_ENROLMENTS}
`;

/**
 * Replaces `User(where: { id })`, which the client only ever called with the
 * signed-in user's own id — and which an anonymous caller could point at any
 * account. There is no argument to point anywhere now.
 */
export const GET_ME = gql`
  query getMe {
    me {
      ...UserSummary
      ...UserEnrolments
      ...UserProfiles
    }
  }
  ${USER_SUMMARY}
  ${USER_ENROLMENTS}
  ${USER_PROFILES}
`;

/** One account, for the administration screens only. */
export const GET_SINGLE_USER = gql`
  query getUser($id: String!) {
    user(id: $id) {
      ...UserSummary
      ...UserEnrolments
      ...UserProfiles
    }
  }
  ${USER_SUMMARY}
  ${USER_ENROLMENTS}
  ${USER_PROFILES}
`;
